import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { links } from '../../constants/general';
import Close from '../common/ui/Close';
import Validator from '../common/forms/Validator';
import FormActionButtons from '../common/forms/FormActionButtons';
import SwitchRow from '../common/forms/SwitchRow';
import ErrorMessage from '../common/forms/ErrorMessage';

export default class TermsConfirmationModal extends Validator {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    acceptTermsAndAgreement: PropTypes.func.isRequired,
    cancelTermsAndAgreement: PropTypes.func.isRequired
  };

  validationRules = {
    tcIsAccepted: { requiredCheckbox: true },
    csaIsAccepted: { requiredCheckbox: true }
  };

  state = {
    tcIsAccepted: false,
    csaIsAccepted: false
  };

  handleChange = name => this.setState(prevState => ({ [name]: !prevState[name] }));

  handleSubmit = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      this.props.acceptTermsAndAgreement();
    }
  };

  render () {
    const { isOpen, cancelTermsAndAgreement } = this.props;

    return (
      <Modal isOpen={isOpen}>
        <div className='modal-header'>
          <div className='modal-title'>You must accept the Terms and Conditions and Client Service Agreement in order to continue</div>
          <Close onClick={cancelTermsAndAgreement} />
        </div>

        <form className='modal-body' onSubmit={this.handleSubmit}>
          <div className='form-group'>
            <div className='d-flex align-items-center'>
              <SwitchRow onChange={() => this.handleChange('tcIsAccepted')} checked={this.state.tcIsAccepted} />
              <a className='ml-3' href={links.termsAndConditions} target='_blank'>Terms and Conditions</a>
            </div>
            <ErrorMessage errorText={this.validationErrors.tcIsAccepted} />
          </div>
          <div className='form-group'>
            <div className='d-flex align-items-center'>
              <SwitchRow onChange={() => this.handleChange('csaIsAccepted')} checked={this.state.csaIsAccepted} />
              <a className='ml-3' href={links.clientServiceAgreement} target='_blank'>Client Service Agreement</a>
            </div>
            <ErrorMessage errorText={this.validationErrors.csaIsAccepted} />
          </div>

          <FormActionButtons onClickCancel={cancelTermsAndAgreement} submitTitle='Accept' />
        </form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/TermsConfirmationModal.js